import { render, staticRenderFns } from "./modelPZ.vue?vue&type=template&id=4c8fb904&scoped=true"
import script from "./modelPZ.vue?vue&type=script&lang=js"
export * from "./modelPZ.vue?vue&type=script&lang=js"
import style0 from "./modelPZ.vue?vue&type=style&index=0&id=4c8fb904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fb904",
  null
  
)

export default component.exports